import { z } from 'zod'

export const PASSWORD_MIN_LENGTH = 10
/** Limite superior para evitar abuso do hash (Argon2) com entradas gigantes. */
export const PASSWORD_MAX_LENGTH = 128

export const PASSWORD_MESSAGES = {
  required: 'Informe a senha.',
  tooShort: `A senha precisa ter pelo menos ${PASSWORD_MIN_LENGTH} caracteres.`,
  tooLong: `A senha pode ter no máximo ${PASSWORD_MAX_LENGTH} caracteres.`,
  missingLetter: 'A senha precisa ter pelo menos uma letra.',
  missingNumber: 'A senha precisa ter pelo menos um número.',
} as const

/** Texto de ajuda exibido junto ao campo de nova senha. */
export const PASSWORD_RULE_HINT = `Use pelo menos ${PASSWORD_MIN_LENGTH} caracteres, com letras e números.`

const LETTER = /\p{L}/u
const DIGIT = /\d/

/** Regra de senha para criação e troca (não usar no login). A senha nunca é alterada (sem trim). */
export const passwordSchema = z
  .string({ error: PASSWORD_MESSAGES.required })
  .min(PASSWORD_MIN_LENGTH, { error: PASSWORD_MESSAGES.tooShort })
  .max(PASSWORD_MAX_LENGTH, { error: PASSWORD_MESSAGES.tooLong })
  .regex(LETTER, { error: PASSWORD_MESSAGES.missingLetter })
  .regex(DIGIT, { error: PASSWORD_MESSAGES.missingNumber })

export interface PasswordChecklist {
  minLength: boolean
  hasLetter: boolean
  hasNumber: boolean
}

/** Estado de cada requisito, para a lista de verificação na tela de troca de senha. */
export function checkPasswordRules(password: string): PasswordChecklist {
  return {
    minLength: password.length >= PASSWORD_MIN_LENGTH,
    hasLetter: LETTER.test(password),
    hasNumber: DIGIT.test(password),
  }
}
